// extracted by mini-css-extract-plugin
export default {"headerBar":"iJ-z","pointsSection":"jJ-z","goToDashboard":"kJ-z"};